import { render, staticRenderFns } from "./productionIssue.vue?vue&type=template&id=23a41135&scoped=true"
import script from "./productionIssue.vue?vue&type=script&lang=js"
export * from "./productionIssue.vue?vue&type=script&lang=js"
import style0 from "./productionIssue.vue?vue&type=style&index=0&id=23a41135&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a41135",
  null
  
)

export default component.exports